/**
 * Created by r4zi4l on 26.01.2021
 */

const UseEnergyButton = cleverapps.UI.Button.extend({
    ctor: function (options) {
        this.price = options.energy;

        this._super({
            width: options.width,
            height: options.height,
            text: `%%${this.price}`,
            textVariant: cleverapps.lives.canTake(this.price) ? cleverapps.UI.Button.TEXT_REGULAR : cleverapps.UI.Button.TEXT_EMPHASIS,
            onClicked: options.onClicked,
            type: options.type
        });
    }
});